var _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b22234",
    d: "M0 0h30v2H0zm0 4h30v2H0zm0 4h30v2H0zm0 4h30v2H0zm0 4h30v2H0z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 10,
    fill: "#3c3b6e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 2,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 2,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 2,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 5,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 5,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 5,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 8,
    r: 0.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.d49e68b790f28d466dc80436120a1e5a.svg";
export { ForwardRef as ReactComponent };